import { times } from 'ramda';

export const parseRegExpToGetLengthValues = (regexp) => {
  const endOfStrIndex = regexp.lastIndexOf('$');
  const bracketOpeningIndex = regexp.lastIndexOf('{', endOfStrIndex);
  const bracketClosingIndex = regexp.lastIndexOf('}', endOfStrIndex);
  const interval = regexp.slice(bracketOpeningIndex + 1, bracketClosingIndex);

  return ({
    min: Number(interval.split(',')[0]),
    max: Number(interval.split(',')[1]),
  });
};

const getResultRegExpTestValue = ({ value, regexp, userLogin, userInternetLogin }) => {
  const { min, max } = parseRegExpToGetLengthValues(regexp);
  const baseRegExp = new RegExp(regexp);
  const regExpWithLogins = userInternetLogin
    ? new RegExp(`^(?!.*${userInternetLogin})(?!.*${userLogin}).{${min},${max}}$`)
    : new RegExp(`^(?!.*${userLogin}).{${min},${max}}$`);

  return baseRegExp.test(value) && regExpWithLogins.test(value);
};

export const getNewPasswordHint = (args) => {
  if (!args.value) return null;

  if (args.currentPassword === args.value) {
    return 'same';
  }

  if (args.value.length < parseRegExpToGetLengthValues(args.regexp).min) {
    return 'short';
  }

  const result = getResultRegExpTestValue({ ...args });

  return result ? 'good' : 'bad';
};

export const getRandomPassword = (args) => {
  const allowedCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const password = times(() => allowedCharacters
    .charAt(Math.floor(Math.random() * allowedCharacters.length)), 10).join('');
  const checkResult = getResultRegExpTestValue({ value: password, ...args });

  return checkResult ? password : getRandomPassword(args);
};
